import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  MAIN_URL,
  PORT,
  API_GET_EXCHANGE_CERTIFICATES_SEARCH,
  API_GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE,
  API_GET_EXCHANGE_APP_BY_ID,
} from "../../constants/constants";

import {
  ADD_NEW_DATA_EXCHANGE_CERTIFICATES,
  GET_DATA_BY_SEARCH_PARAMS_EXCHANGE_CERTIFICATES,
  GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE,
  CLEAR_EXCHANGE_APP_DATA,
  GET_EXCHANGE_APP_BY_ID,
} from "../types";

export function getDataExchangeCertificatesBySearchParams(params, page) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT + API_GET_EXCHANGE_CERTIFICATES_SEARCH + "page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => {
      console.log(err);
    });
    if (request.status === 200) {
      const response = await request.json();
      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_EXCHANGE_CERTIFICATES,
        data: response,
      });
    }
  };
}

export function addNewDataExchangeCertificates(object) {
  return {
    type: ADD_NEW_DATA_EXCHANGE_CERTIFICATES,
    data: object,
  };
}

export function getCertificateInfoByNumExchange(num, typeId) {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ licenseNum: num, licenseTypeId: typeId }),
    }).catch((err) => {
      console.log(err);
    });
    const data = {};
    if (request.status === 200) {
      const response = await request.json();
      if (Number(response.boatDrivingLicenseTypeId) === Number(typeId)) {
        response.validTypeId = [];
        response.validZoneId = [];
        response.validTypeName = "";
        response.validZoneName = "";
        response.validVal.forEach((item, index) => {
          response.validTypeName +=
            item.validTypeName !== null
              ? index === response.validVal.length - 1
                ? item.validTypeName
                : `${item.validTypeName}, `
              : "";
          response.validZoneName +=
            item.validZoneName !== null
              ? index === response.validVal.length - 1
                ? item.validZoneName
                : `${item.validZoneName}, `
              : "";
          response.validTypeId.push(item.dlValidTypeId);
          response.validZoneId.push(item.dlValidZoneId);
        });

        data.response = {
          ...response,
          licenseTypeId: typeId,
          appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
          licenseTypeIdName: typeId === 1 ? "Республиканское" : "Международное",
        };
        data.wrongTypeErr = false;
        data.licenseNotExistErr = false;
      } else {
        data.response = {};
        data.wrongTypeErr = `Удостоверение с номером ${num} иного типа`;
        data.licenseNotExistErr = false;
      }
      dispatch({
        type: GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE,
        data: data,
      });
    } else {
      const response = await request.text();
      data.response = {};
      data.wrongTypeErr = false;
      data.licenseNotExistErr = response;
      dispatch({
        type: GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE,
        data: data,
      });
    }
  };
}

export function getExchangeAppDataById(id) {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_EXCHANGE_APP_BY_ID + id).catch((err) => {
      console.log(err);
    });
    if (request.status === 200) {
      const response = await request.json();
      response.licenseTypeId = response.boatDrivingLicenseTypeId;
      response.licenseTypeIdName = response.boatDrivingLicenseTypeName;
      response.licenseNum = response.licenseNum || response.licenseNumExchange;
      response.licenseDate = response.licenseDate || response.licenseDateExchange;
      response.agent = false;
      Object.entries(response).forEach((item) => {
        if (item[0].includes("agent") && !!item[1]) {
          response.agent = true;
        }
      });
      if (response.documents) {
        response.appFileId = response.documents.docid;
        response.viewFileName = response.documents.docname;
      }
      // response.inspector = response.appUser;
      response.validTypeId = [];
      response.validZoneId = [];
      response.validTypeName = "";
      response.validZoneName = "";
      response.validVal.forEach((item, index) => {
        response.validTypeName +=
          index === response.validVal.length - 1 ? item.validTypeName : `${item.validTypeName}, `;
        response.validZoneName +=
          index === response.validVal.length - 1 ? item.validZoneName : `${item.validZoneName}, `;
        response.validTypeId.push(item.dlValidTypeId);
        response.validZoneId.push(item.dlValidZoneId);
      });
      dispatch({
        type: GET_EXCHANGE_APP_BY_ID,
        data: response,
      });
    }
  };
}

export function clearExchangeAppData() {
  return {
    type: CLEAR_EXCHANGE_APP_DATA,
    data: {},
  };
}
